import Vue from 'vue'
import VueResource from 'vue-resource'
import util from 'util/common'
Vue.use(VueResource)

const buildPath = function (path) {
  let p = util.isArray(path) ? path : [path]
  return ['/api', ...p].join('/')
}

const onAuthRequired = (context) => {
  var redirect = context.$route.fullPath
  context.$router.push({
    path: '/login',
    query: {
      redirect: redirect
    }
  })
}

const cacheEventList = (context, events) => {
  context.$store.commit('updateEventList', events)
}
const fetchEventList = (context, query) => {
  let q = query ? { ...query } : {}
  if (!q.status) {
    q.status = 'all'
  }
  if (q.enddate_from) {
    q.enddate_from = util.parseDateToSendAPI(q.enddate_from)
  }
  if (q.enddate_to) {
    q.enddate_to = util.parseDateToSendAPI(q.enddate_to)
  }
  return context.$http.get(buildPath('event'), { params: q }).then(res => {
    cacheEventList(context, res.body)
    return res.body
  })
}
const fetchEvent = (context, eventId) => {
  return context.$http.get(buildPath(['event', eventId]))
    .then(res => res.body.event)
}

export default {
  login (context, cred) {
    return context.$http.post(buildPath('login'), cred)
  },

  fetchEventList,
  fetchEvent,
  registerNewEvent (context, data) {
    return context.$http.post(buildPath('event'), data)
  },
  updateEvent (context, data) {
    return context.$http.put(buildPath(['event', data.event_id]), data)
  },
  deleteEvent (context, eventId) {
    return context.$http.delete(buildPath(['event', eventId]))
    .then(_ => {
      context.$store.commit('deleteByEventId', eventId)
    })
  },

  sendInquiry (context, inquiry) {
    return context.$http.post(buildPath(['lecturer', 'inquiry']), inquiry)
  },

  updateLecturerProfile (context, profile) {
    return context.$http.post(buildPath(['lecturer', 'profile']), profile)
  },
  fetchLecturerProfile (context) {
    return context.$http.get(buildPath(['lecturer', 'profile']))
      .then(p => p.body)
  },

  fetchPrefectures (context) {
    return context.$http.get(buildPath('prefecture'))
    .then(res => res.body.prefecture)
  },

  sendEventReport (context, report) {
    return context.$http.post(buildPath(['event', 'report']), report)
  },

  fetchNotReported () {
    // return new Promise((resolve, reject) => { resolve(false) })
    return Vue.http.get(buildPath(['event', 'notreport']))
    .then(res => res.body.not_report)
  },

  sendImage (context, kind, file) {
    let formData = new FormData()
    formData.append('uploadfile', file)
    return context.$http.post(buildPath(['image', kind]), formData)
    .then(res => res.body)
  },

  resetPassword (context, email) {
    return context.$http.post(buildPath(['password', 'reset']), email)
      .then(res => res.body)
  },

  changePassword (context, pass) {
    return context.$http.put(buildPath('password'), pass)
  },

  changeEmail (context, email) {
    return context.$http.post(buildPath('email'), email)
      .then(res => res.body)
  },

  changedEmail (context, token) {
    return context.$http.get(buildPath(['email', token]))
      .then(res => res.body)
  },

  sendClientError (context, errorMessage) {
    return context.$http.post(buildPath(['client', 'error']), errorMessage)
      .then(res => res.body)
  },

  onAuthRequired,

  sendRemain (context, param) {
    return context.$http.post(buildPath(['event', 'remand']), param)
      .then(res => res.body)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js